import React, { useCallback, useMemo } from 'react';
import Form from '@/common/components/Form/index';
import styles from '@/common/containers/Forms/PrimaryAccountUser/styles.less';
import { TextInput } from '@/common/components/Inputs/index';
import * as yup from 'yup';
import { useTranslation } from 'react-i18next';

const PrimaryAccountUser = ({
  className,
  initialValues = {},
  onSubmit,
  hideBlockLabel = false,
  disableEmail = false,
  formId,
}) => {
  const { t } = useTranslation();
  const validation = useMemo(
    () =>
      yup.object({
        firstName: yup.string().trim().required(t('Enter first name')),
        middleName: yup.string().trim(),
        lastName: yup.string().trim().required(t('Enter last name')),
        email: yup
          .string()
          .email(t('Must be valid email address'))
          .required(t('Enter email')),
        mobilePhoneNumber: yup.string().trim(),
        homePhoneNumber: yup.string().trim(),
      }),
    [t]
  );
  const disableEmailTip = t(
    'Email couldn’t be updated. If you made a mistake, transfer permission to a new user'
  );
  const form = useMemo(() => {
    return [
      {
        name: 'firstName',
        label: t('First name'),
        required: true,
      },
      {
        name: 'middleName',
        label: t('Middle name'),
      },
      {
        name: 'lastName',
        label: t('Last name'),
        required: true,
      },
      {
        name: 'email',
        label: t('Email'),
        tip: disableEmail ? disableEmailTip : '',
        disabled: disableEmail,
        required: true,
      },
      {
        name: 'mobilePhoneNumber',
        label: t('Tel. (mobile)'),
        mask: '000-000-0000',
      },
      {
        name: 'homePhoneNumber',
        label: t('Tel. (home)'),
        mask: '000-000-0000',
      },
    ];
  }, [disableEmail, disableEmailTip, t]);

  const renderInputs = useCallback(
    (form) =>
      form.map((input) => (
        <TextInput
          key={input.name}
          className={styles.blockBodyRowItem}
          {...input}
        />
      )),
    []
  );

  return (
    <Form
      className={className}
      validation={validation}
      initialValues={initialValues}
      onSubmit={onSubmit}
      id={formId}
    >
      <div className={styles.block}>
        {!hideBlockLabel && (
          <div className={styles.blockHeader}>{t('Primary Account User')}</div>
        )}
        <div className={styles.blockBody}>
          <div className={styles.blockBodyRow}>
            {renderInputs(form.slice(0, 3))}
          </div>
          <div className={styles.blockBodyRow}>
            {renderInputs(form.slice(3, 6))}
          </div>
        </div>
      </div>
    </Form>
  );
};

export default PrimaryAccountUser;
